import { FormlyFieldConfig, FormlyTemplateOptions } from '@ngx-formly/core';

export interface ISnFileUploadTemplateOptionsInterface extends FormlyTemplateOptions {
  allowPreview?: boolean;
  multiple?: boolean;
  allowedContentTypes?: string[];
  accept?: string;
  fileUploaded?(field: FormlyFieldConfig, event: any): void;
}
